import * as Style from './RadioGroup.style';

interface Props {
  options: { label: string; value: string }[];
}

const RadioGroup = ({ options, ...rest }: Props) => {
  return <Style.RadioGroup options={options} {...rest} />;
};

export default RadioGroup;
